import React from 'react';

const IconArrow = (props) => {

  return (
    <svg onClick={props.onClick} width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.65685 14.7017L0.292892 8.22017C-0.0976315 7.82243 -0.0976315 7.17757 0.292892 6.77983L6.65685 0.298304C7.04738 -0.0994349 7.68054 -0.0994349 8.07107 0.298304C8.46159 0.696042 8.46159 1.3409 8.07107 1.73864L3.41421 6.48153L21 6.48153V8.51847L3.41421 8.51847L8.07107 13.2614C8.46159 13.6591 8.46159 14.304 8.07107 14.7017C7.68054 15.0994 7.04738 15.0994 6.65685 14.7017Z" fill="black"/>
    </svg>
  );
}

export default IconArrow;